export default __webpack_public_path__ + "static/media/img14.5216c240.jpg";